/*
 * @Description: webview相关路径
 * @Date: 2025-12-09 14:55:46
 */
import { XCX_PATH } from '@/config';

// C端任务路径
export const WEBVIEW_TASK_URL = {
  // 数字问卷
  5: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`,
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`,
    share: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`
  },
  // 数字专区
  6: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-6/task-6`,
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-6/task-6`
  },
  // 数字拜访
  17: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-17-zone/task-17-zone`, // 任务进入页
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-17-zone/task-17-zone`, // 任务详情
    share: `${XCX_PATH}/#/views-b/task/src/views/task-17-share/task-17-share` // 反馈页面
  },
  // 协定服务
  19: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-19/task-19`,
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-19/task-19`
  },
  // 可配置
  20: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`,
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`,
    share: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`
  },
  // 数字问卷
  21: {
    home: `${XCX_PATH}/#/views-b/task/src/views/task-21-zone/task-21-zone`,
    detail: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`,
    share: `${XCX_PATH}/#/views-b/task/src/views/task-52021/task-52021`
  }
};
// 首页
export const WEBVIEW_HOME_URL = `${XCX_PATH}/#/views/home/src/views/home/home`;
// 企业招商
export const INVESTMENT_URL = `${XCX_PATH}/#/views-c/investment/src/views/investment-detail/investment-detail`;
